import styled from 'styled-components';

export const StyledTabsWrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;

  .ant-tabs {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .ant-tabs-nav {
    flex: 0 0 auto;
    padding: 0 24px;
    margin: 0;
  }

  .ant-tabs-content-holder {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
  }

  .ant-tabs-content {
    height: 100%;
  }

  .ant-tabs-tabpane {
    height: 100%;
  }

  .ant-tabs-tab-btn {
    font-weight: 700;
  }
`;
